import { ref, onMounted } from 'vue';

// 单例模式,确保所有组件使用同一个状态
const isDark = ref(false);

export function useDark() {
  // 初始化主题(读取 localStorage 与系统偏好,只执行一次)
  const initTheme = () => {
    // 确保在浏览器环境中执行
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
      return;
    }

    try {
      const savedTheme = localStorage.getItem('theme');
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

      if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
        isDark.value = true;
        document.documentElement.setAttribute('data-theme', 'dark');
      } else {
        isDark.value = false;
        document.documentElement.setAttribute('data-theme', 'light');
      }
    } catch (e) {
      console.warn('Theme initialization failed:', e);
    }
  };

  // 立即同步调用版(供 main.js 在挂载前执行,避免页面闪烁)
  const init = () => {
    initTheme();
  };

  const toggleDark = () => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
      return;
    }

    try {
      isDark.value = !isDark.value;
      if (isDark.value) {
        document.documentElement.setAttribute('data-theme', 'dark');
        localStorage.setItem('theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-theme', 'light');
        localStorage.setItem('theme', 'light');
      }
    } catch (e) {
      console.warn('Theme toggle failed:', e);
    }
  };

  // 在组件挂载时兜底执行一次(防止在 main.js 中未调用)
  onMounted(() => {
    initTheme();
  });

  return {
    isDark,
    toggleDark,
    init
  };
}
